import { useState, useEffect } from "react";
import Sidebar from "../components/dashboard/Sidebar";
import DashboardHeader from "../components/dashboard/HeaderDashboard";
import NotificationsTable from "../components/ui/NotificationsTable";
import { useSession } from "@hooks/useSession";
import { AppContextState } from "@state";
import State from "@state";
import NotificationController from "@/network/controllers/notification.controller";
import { STATE } from "@state";
import NavigationService from "@services/navigation.service.js";
import AuthController from "@controllers/auth.controller.js";

export default function Notifications() {
  const { user } = useSession();
  const isCRO =
    STATE[AppContextState.ROLE_CONTEXT] === AppContextState.ROLE_CONTEXT_CRO;
  const [activeFilter, setActiveFilter] = useState("All");
  const [notifications, setNotifications] = useState([]);

  const normalizeNotifications = (notifications) =>
  notifications.map((n, index) => ({
    id: index + 1,
    rawId: n.notification_id, 
    date: new Date(n.notification_date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "UTC",
    }) + " UTC",
    studyName: n.study_name,
    type: n.notification_type,
    notification: n.notification_description,
    status: n.notification_status,
  }));


  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      console.log("=== fetchNotifications START === Notifications.jsx === key: 556701 ===");
      console.log("→ user.userId:", user?.userId);
  
      const response = await NotificationController.getUserNotifications(user.userId);
  
      console.log("=== API response === Notifications.jsx === key: 556702 ===");
      console.dir(response, { depth: null, colors: true });
  
      if (response?.success && Array.isArray(response.data)) {
        const normalized = normalizeNotifications(response.data);
  
        console.log("=== Notifications normalisées === Notifications.jsx === key: 556703 ===");
        console.dir(normalized, { depth: null, colors: true });
  
        setNotifications(normalized);
  
        const unreadIds = normalized
          .filter(n => n.status === "pending" && !!n.rawId)
          .map(n => n.rawId);
  
        console.log("=== IDs à marquer comme lus === Notifications.jsx === key: 556704 ===");
        console.log("→ unreadIds:", unreadIds);
  
        if (unreadIds.length > 0) {
          try {
            const markResponse = await NotificationController.markNotificationsAsRead(unreadIds, user.userId);
  
            console.log("=== Réponse mark-as-read === Notifications.jsx === key: 556705 ===");
            console.dir(markResponse, { depth: null, colors: true });
          } catch (error) {
            console.error("Erreur mark-as-read:", error);
          }
        } else {
          console.log("Aucune notification à marquer comme lue.");
        }
      } else {
        console.warn("⚠️ Échec de récupération des notifications:", response?.message || "Erreur inconnue");
      }
  
      setLoading(false);
      console.log("=== fetchNotifications END === Notifications.jsx === key: 556706 ===");
    };
  
    if (user?.userId) {
      fetchNotifications();
    }
  }, [user?.userId]);
  
  // filters based on role
  const filterButtonsCRO = [
    "All",
    "New study",
    "Study update",
    "Master ICF update",
    "Milestone update",
    "Study site",
    "Role management",
  ];

  const filterButtonsInvestigator = [
    "All",
    "Patient",
    "New study",
    "Milestone update",
    "Site ICF",
  ];

  // Use the appropriate data and filters based on role

  const filterButtons = isCRO ? filterButtonsCRO : filterButtonsInvestigator;

  // Filter notifications based on active filter
  const filteredNotifications = notifications.filter((notification) =>
  activeFilter === "All"
    ? true
    : notification.type === activeFilter
);


  // Event handlers
  const handleCreateStudy = () => {
    NavigationService.navigateTo("/create-study");
  };

  const handleSignOut = () => {
    AuthController.logout();
  };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  // Function to determine text color based on notification type
  const getTextColorClass = (type) => {
    if (isCRO) {
      switch (type) {
        case "Master ICF update":
          return "text-[#8B0000]"; // Dark red
        case "Milestone update":
          return "text-[#8B0000]"; // Dark red
        case "Study update":
          return "text-[#8B0000]"; // Dark red
        default:
          return "text-gray-700";
      }
    } else {
      switch (type) {
        case "Milestone update":
          return "text-[#8B0000]"; // Dark red
        case "Site ICF":
          return "text-[#8B0000]"; // Dark red
        default:
          return "text-gray-700";
      }
    }
  };

  const columns = [
    { key: "date", header: "Date" },
    { key: "studyName", header: "Study name" },
    { key: "type", header: "Type" },
    { key: "notification", header: "Notification" },
  ];
  

  return (
    <div className="flex h-screen bg-dashboard-bg">
      <Sidebar
        title="OSHIMED"
        activeLink="Notifications"
        companyName={isCRO ? "Company Name" : undefined}
        investigatorName={!isCRO ? "Investigator Name" : undefined}
        userRole={isCRO ? "cro" : "investigator"}
        onCreateStudy={isCRO ? handleCreateStudy : undefined}
        onSignOut={handleSignOut}
      />
      <div className="flex-1 flex flex-col overflow-hidden p-4 md:p-6 lg:p-8">
        <DashboardHeader
          title="Notifications"
          buttons={filterButtons}
          activeButton={activeFilter}
          onButtonClick={handleFilterChange}
        />

        <div className="flex-1 overflow-auto bg-dashboard-bg">
          {/* Notifications section */}
          <div className="flex-1 mt-2 rounded-xl  bg-dashboard-bg1">
            <main className="p-3 sm:p-4 md:p-6">
              <h2 className="text-lg font-semibold mb-6">
                Lasts notifications
              </h2>

              {/* Notifications table with the new component */}
              {loading ? (
                <div className="text-center text-gray-500 p-8">
                  Loading notifications...
                </div>
              ) : (
                <NotificationsTable
                  notifications={filteredNotifications}
                  columns={columns}
                  emptyMessage="No notifications found for this filter."
                  getTextColorClass={getTextColorClass}
                />
              )}

              <div className="h-20"></div>
              <div className="h-20"></div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
